import ElevvaLoader from "../../ui/ElevvaLoader/ElevvaLoader";
import React from "react";
import "./mobile-button.css";

const MobileButton = ({
    text,
    onClick,
    type = "button",
    className = "",
    variant = "primary",
    bg = null,
    disabled = false,
    loading = false,
    icon = null,
    size = "md",
    label = null
}) => {
    const isSmall = size === "sm";
    const handleClick = (e) => {
        if (onClick) {
            onClick(e);
        }
    };

    const isPrimary = variant === "primary";
    const finalBg = bg || (isPrimary ? "linear-gradient(90deg, #394F65 0%, #4A6581 100%)" : "white");
    const finalColor = (isPrimary || bg) ? 'white' : '#394F65';

    const padding = isSmall ? '8px 16px' : '14px 20px';
    const fontSize = isSmall ? '13px' : '16px';
    const borderRadius = isSmall ? '10px' : '15px';

    const buttonElement = (
        <button
            type={type}
            onClick={handleClick}
            disabled={disabled || loading}
            className={`btn mobile-button ${size} ${!isSmall ? 'w-100' : ''} ${variant} ${className}`}
            style={{
                background: finalBg,
                border: bg ? 'none' : (isPrimary ? 'none' : '1px solid #E2E8F0'),
                color: finalColor,
                padding: padding,
                fontSize: fontSize,
                borderRadius: borderRadius,
                opacity: (disabled || loading) ? 0.7 : 1,
                cursor: (disabled || loading) ? 'not-allowed' : 'pointer',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                gap: '10px'
            }}
        >
            {loading ? (
                <>
                    <ElevvaLoader variant="inline" inverse={isPrimary || !!bg} decorative />
                    <span style={{ color: finalColor }}>Procesando...</span>
                </>
            ) : (
                <>
                    {icon && <i className={icon}></i>}
                    {text}
                </>
            )}
        </button>
    );

    if (label) {
        return (
            <div className="mobile-button-container">
                <label className="mobile-button-label">{label}</label>
                {buttonElement}
            </div>
        );
    }

    return buttonElement;
};

export default MobileButton;
